import { pickBy } from 'lodash-es';

/**
 * null & undefined 값을 갖는 키를 전부 제거합니다.
 */
export const pickValid = <T extends object>(value: T) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return pickBy(value, v => v != null);
};
